import React from 'react'
import profilePic from "../../Assets/me2.png";
import './style.css'
const AboutPic = () => {
  return (
    <div className="AboutProfile">
      <div className="AboutProfilePic">
        <img src={profilePic} alt="ProfilePic"></img>
      </div>
      </div>
  )
}

export default AboutPic
